var _rect, _circle, _circle2, _circle3, _circle4, _path, _circle5, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCafe05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.71875,
    width: 350,
    height: 233,
    fill: "#C57E56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.058,
    cy: 140.438,
    r: 69.1201,
    transform: "rotate(-12.0382 240.058 140.438)",
    fill: "#232444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 131.174,
    r: 63.4267,
    transform: "rotate(-12.0382 245.23 131.174)",
    fill: "#686CD3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 131.172,
    r: 60.4937,
    transform: "rotate(-12.0382 245.23 131.172)",
    fill: "#EBECFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 131.172,
    r: 59.0272,
    transform: "rotate(-12.0382 245.23 131.172)",
    fill: "#D97B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.95 155.942L208.287 121.427L222.453 137.089L280.594 152.858L261.929 192.78C257.358 193.922 252.591 194.58 247.682 194.693C220.651 195.317 197.116 179.262 186.95 155.942Z",
    fill: "#1E1F2F",
    fillOpacity: 0.86
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.188,
    cy: 133.533,
    r: 35.1963,
    transform: "rotate(-15.7648 245.188 133.533)",
    fill: "#686CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.516 166.908C275.808 161.461 287.032 141.407 281.586 122.115C276.139 102.824 256.085 91.5994 236.793 97.0457C219.435 101.946 208.609 118.673 210.58 136.029C211.758 154.903 227.823 169.456 246.809 168.672C250.024 168.54 253.119 167.976 256.041 167.038C256.199 166.996 256.358 166.952 256.516 166.908ZM256.041 167.038C270.602 162.367 280.862 148.426 280.201 132.405C279.407 113.169 263.169 98.2183 243.933 99.0123C224.697 99.8063 209.747 116.044 210.541 135.28C210.551 135.531 210.564 135.78 210.58 136.029C210.799 137.963 211.178 139.904 211.724 141.838C217.125 160.971 236.896 172.169 256.041 167.038Z",
    fill: "#333679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.774 170.157C279.084 164.141 291.482 141.989 285.466 120.678C279.45 99.3682 257.298 86.9699 235.988 92.9859C214.678 99.002 202.279 121.154 208.295 142.464C214.311 163.775 236.464 176.173 257.774 170.157ZM256.525 165.727C275.389 160.401 286.365 140.791 281.039 121.926C275.714 103.062 256.103 92.0861 237.239 97.4117C218.374 102.737 207.398 122.348 212.724 141.212C218.05 160.077 237.66 171.053 256.525 165.727Z",
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 281.396,
    y: 118.738,
    width: 16.1316,
    height: 6.59931,
    rx: 3.29966,
    transform: "rotate(-15.7648 281.396 118.738)",
    fill: "#F2F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe05);
export default __webpack_public_path__ + "static/media/cafe_05.b86c680aee7f05333e90b568bcd79c95.svg";
export { ForwardRef as ReactComponent };